import styled from 'styled-components';

export const Eye = styled.img`
  padding: 10px 0px 10px 8px;
  cursor: pointer;
`;
